"use strict";

import {setDate} from "@elements/datepicker";
import {ISOStringToDate} from "@elements/date-utils";

export function init() {
    let $ajaxForm = $('.js-ajax-form');
    $ajaxForm.on('reset.ajax-form', function() {
        let $form = $(this);

        // @elements/ajax-form's reset handler empties every field via .val('');
        // datepickers that opt in via data-datepicker-reset-value should end up
        // there instead of blank.
        let $resetDatepickers = $form.find('.js-datepicker[data-datepicker-reset-value]');
        $resetDatepickers.each(function () {
            let $datepicker = $(this);
            setDate($datepicker, ISOStringToDate($datepicker.data('datepickerResetValue')));
        });

        // setDate() applies asynchronously (it waits for jQuery UI to be ready),
        // so defer until it has had a chance to run before reacting further.
        setTimeout(function () {
            // setDate() sets the alt-field's value via .val(), which doesn't fire
            // 'change' - resync dependents (e.g. the floating-label's has-value
            // class) that only react to that event.
            $resetDatepickers.find('.js-datepicker__alt-field').trigger('change');

            // opt out via data-ajax-form-reset-submit="false" on .js-ajax-form
            // when the reset button should only reset the values, not re-query
            if ($form.data('ajaxFormResetSubmit') === false) {
                return;
            }

            $form.find('.js-ajax-form__form').submit();
        }, 0);
    });
}